import React from 'react';
import { Category } from '../services/api';

interface Props {
  category: Category;
  isSelected: boolean;
  onSelect: (category: Category) => void;
}

export const CategoryCard: React.FC<Props> = ({ category, isSelected, onSelect }) => {
  return (
    <div
      className={`category-card${isSelected ? ' selected' : ''}`}
      onClick={() => onSelect(category)}
    >
      <div className="category-content">
        <p className="category-name">{category.name}</p>
        {category.description && (
          <p className="category-description">{category.description}</p>
        )}
        {category.price && (
          <p className="category-price">{category.price}</p>
        )}
      </div>
      <div className="category-select-indicator">
        <div className="indicator-circle" />
      </div>
    </div>
  );
};

export default CategoryCard;
